import React, { useEffect, useRef } from 'react';
import { useObserver } from 'mobx-react-lite';

import useUI from 'hooks/use-ui';
import useCart from 'hooks/use-cart';
import type { Dispensaries } from 'src/gql/graphql';

import DispensarySubheaderDesktop from './dispensary-subheader-desktop';

export type DispensarySubheaderWrapperProps = {
  dispensary: Dispensaries;
};

export default function DispensarySubheaderWrapper({ dispensary }: DispensarySubheaderWrapperProps): JSX.Element {
  const UI = useUI();
  const cart = useCart();
  const itemCount = useObserver(() => cart.itemCount);
  const isGlobalHeaderInView = useObserver(() => UI.isGlobalHeaderInView);
  const isDispensaryHeaderInView = useObserver(() => UI.isDispensaryHeaderInView);
  const showCartDrawer = useObserver(() => UI.showCartDrawer);

  const handleToggleCart = (): void => (showCartDrawer ? UI.closeCartDrawer() : UI.openCartDrawer());

  const recDispensary = useObserver(() => dispensary.recDispensary);
  const medicalDispensary = useObserver(() => dispensary.medicalDispensary);
  const showMenuTypeDropdown = recDispensary && medicalDispensary;

  const cartButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    UI.setCartButtonRef(cartButtonRef);
    return () => UI.clearCartButtonRef();
  }, [UI, cartButtonRef]);

  return (
    <DispensarySubheaderDesktop
      dispensary={dispensary}
      itemCount={itemCount}
      cartButtonRef={cartButtonRef}
      isGlobalHeaderInView={isGlobalHeaderInView}
      isDispensaryHeaderInView={isDispensaryHeaderInView}
      recDispensary={recDispensary}
      showMenuTypeDropdown={showMenuTypeDropdown}
      onToggleCart={handleToggleCart}
    />
  );
}
